<template>

    <modal :show="showModal">

        <div class="moic">

            <h1 class="moic__title">{{ $t('invalid_credentials_outlook_title') }}</h1>

            <span class="moic__text">{{ $t(`invalid_credentials_outlook_text_1`) }}</span>

            <span class="moic__text moic__text-bottom">{{ $t(`invalid_credentials_outlook_text_2`) }}</span>

            <button class="btn btn-blue btn-big moic__btn" @click="active2FA">{{ $t(`invalid_credentials_outlook_cta_1`) }}</button>

            <button class="btn btn-grey btn-big moic__btn" @click="back">{{ $t(`invalid_credentials_outlook_cta_2`) }}</button>

        </div>

    </modal>

</template>

<script>

import Tag from '@/modules/tag'

import Modal from '@/components/modal/Modal'

export default {

    name: 'modal-error-google',

    components: {Modal},

    data() {
        return {
            showModal: false
        }
    },

    methods: {

        open() {
            Tag.popupAmplitude(this, 'invalid_credentials_outlook_popup_login_credentials_error')
            this.showModal = true
        },

        active2FA() {
            Tag.clickAmplitude(this, 'invalid_credentials_outlook_event_click_cta_2FA')
            window.open('https://account.live.com/proofs/EnableTfa')
            this.close()
        },

        back() {
            Tag.clickAmplitude(this, 'invalid_credentials_outlook_event_click_cta_back')
            this.close()
        },


        close() {
            this.showModal = false
        }
    }

}

</script>

<style lang="scss" scoped>

.moic {
    position: relative;
    padding: 24px 16px 16px;
    display: flex;
    flex-direction: column;
    max-width: 501px;
    @media screen and (min-width: $above-tablet-length) {
        padding: 32px;
        align-items: center;
    }

    &__title {
        font-size: 21px;
        font-weight: bold;
        line-height: 1.14;
        text-align: center;
        color: $midnight;
    }

    &__text {
        margin-top: 10px;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.5;
        color: $secur-text;
    }

    &__text-bottom {
        margin-bottom: 9px;
    }

    &__btn {
        margin-top: 8px;
        max-width: 300px;
    }
}

</style>
